const direcciónZonaUrbana = (values) => {
    const arrayAddress = [
        values?.via,
        values?.numeroVia,
        values?.letra,
        values?.bis ? "BIS" : "",
        values?.sectorAddress,
        "#",
        values?.numeroViaSecun,
        values?.letraSecun,
        values?.numeroViaGeneradora,
        values?.sectorSecun,
        values?.complemento,
    ];

    let direcciónCompleta;
    direcciónCompleta = arrayAddress.filter((x) => x).join(" ");
    return direcciónCompleta;
};

export default direcciónZonaUrbana;
